import { ColumnLayout } from '@cloudscape-design/components'
// import { ReactNode } from 'react'

export type ColumnsProps = {
    cols: number,
    minWidth?: number,
    disableGutters?: boolean,
    [rest: string]: any,
}

export default (props : ColumnsProps) => {

    return (
        <ColumnLayout 
            disableGutters={props.disableGutters}
            columns={props.cols}
            minColumnWidth={props.minWidth ?? 620}
            {...props.rest} >
                {props.children}
        </ColumnLayout> 
    )
}